import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';
import Service from './Service';

import styles from './ourServices.scss';

const CONTENT_KEYS = {
  title: 'Title',
  description: 'Description',
  features: 'Features',
  ctaButton: 'See Our Services',
};

const OurServices = ({ content, className }) => (
  <div className={classNames(styles.ourServices, className)}>
    <div className={styles.content}>
      <h2 className={styles.title}>{content.title}</h2>
      {content.description && (
        <p className={styles.description}>{content.description}</p>
      )}
      <ol className={styles.features}>
        {content.features.fields.features.map((document) => (
          <Service key={document.sys.id} document={document} />
        ))}
      </ol>
      <Button className={styles.ctaButton} document={content.ctaButton} />
    </div>
  </div>
);

OurServices.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEYS)(OurServices);
